import React from "react";

const FormInputCheckbox = ( { register, onChange, readOnly, label, sectionName, name, style, className, value, defaultValue } ) =>
{
    const classText = className === undefined ? "input-group" : '' ;
    const styleObj = style === undefined ? {} : style ;

    const isHookForm = register !== undefined ;

    const clickHandler = ( event ) =>
    {
        onChange ( event.target.checked ) ;
    }

    return (
        <div className={classText} style={styleObj}>
            <div className="checkbox">
                <label>
                    { isHookForm === true && <input disabled={readOnly} type="checkbox" {...register(sectionName + '.' + name, {})}/> }
                    { isHookForm === false && <input disabled={readOnly} type="checkbox" checked={value} onChange={clickHandler}/> }
                    {label}
                </label>
            </div>
        </div>
    )
}

export { FormInputCheckbox };